/* fb-meters.js — barras de avance del carrito: envío gratis + Promo NFL (boletos).
   Pinta todo [data-fb-meters] de la página (snippets/fb-meters.liquid) a partir del carrito:
     · fb-cart.js llama window.FBMeters.render(cart) en cada repintado (incluye los cambios
       optimistas de cantidad), así las barras van al paso del carrito lateral;
     · además se actualiza sola con /cart.js al cargar y en cart:updated / cart:refresh
       (página del carrito, que se re-renderiza desde el servidor).
   Envío gratis: mismo cálculo que antes (items_subtotal_price contra el mínimo del tema).
   Promo NFL, por PEDIDO (no acumulable): $3,500–$5,499.99 = 1 boleto, desde $5,500 = 2;
   +5 por asador KURO y +15 por Kamado. El importe de los asadores no cuenta para los
   rangos (igual que el conteo del admin). La fila NFL se oculta fuera de la vigencia. */
(function () {
  'use strict';
  if (window.FBMeters) return;

  var LOW = 350000, HIGH = 550000, LOW_T = 1, HIGH_T = 2; // centavos
  var KURO_EACH = 5, KAMADO_EACH = 15;
  var GRILL_TYPE = 'asadores / kuro grill';

  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3.5 3.5v2.5h-7.5z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="6.5" cy="17" r="1.9" fill="var(--fbm-bg,#fff)" stroke="currentColor" stroke-width="1.7"/><circle cx="17.5" cy="17" r="1.9" fill="var(--fbm-bg,#fff)" stroke="currentColor" stroke-width="1.7"/></svg>';
  var BALL = '<svg viewBox="0 0 24 24" aria-hidden="true"><ellipse cx="12" cy="12" rx="9.5" ry="6" transform="rotate(-35 12 12)" fill="#8a5228" stroke="#5c3418" stroke-width="1"/><path d="M8.6 15.4l6.8-6.8M10.4 11.6l1.6 1.6M11.8 10.2l1.6 1.6M13.2 8.8l1.6 1.6" stroke="#f4f1e8" stroke-width="1.3" stroke-linecap="round"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function money(c) {
    var v = Math.max(0, Math.round(c)) / 100;
    var s = (v % 1 ? v.toFixed(2) : String(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + s;
  }
  function plural(n, a, b) { return n + ' ' + (n === 1 ? a : b); }

  function grills(cart) {
    var kuro = 0, kamado = 0, spend = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (String(it.product_type || '').trim().toLowerCase() !== GRILL_TYPE) return;
      var isKamado = /kamado/i.test((it.product_title || '') + ' ' + (it.handle || ''));
      if (isKamado) kamado += it.quantity; else kuro += it.quantity;
      spend += (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
    });
    return { kuro: kuro, kamado: kamado, spend: spend };
  }

  function nflState(cart) {
    var g = grills(cart);
    var total = (cart && cart.total_price) || 0;
    var evaluable = Math.max(0, total - g.spend);
    var spendT = evaluable >= HIGH ? HIGH_T : evaluable >= LOW ? LOW_T : 0;
    var grillT = g.kuro * KURO_EACH + g.kamado * KAMADO_EACH;
    return { evaluable: evaluable, spendT: spendT, grillT: grillT, tickets: spendT + grillT, g: g };
  }

  function nflLive(el) {
    var now = Date.now();
    var s = Date.parse(el.getAttribute('data-nfl-start') || ''), e = Date.parse(el.getAttribute('data-nfl-end') || '');
    return !(isNaN(s) || isNaN(e) || now < s || now > e);
  }

  // Una sola barra: de $0 al rango alto de boletos ($5,500), con marcas en envío gratis,
  // 1 boleto y 2 boletos. Sin promo vigente, la barra va de $0 al mínimo de envío.
  function paint(el, cart) {
    var mini = el.getAttribute('data-variant') === 'mini';
    var n = (cart && cart.item_count) || 0;
    var min = parseInt(el.getAttribute('data-fs-min'), 10) || 0;
    var live = nflLive(el);
    if (!min && !live) { el.innerHTML = ''; el.hidden = true; return; }

    var sub = (cart && (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price)) || 0;
    var fsRem = min ? min - sub : 0, fsDone = !min || fsRem <= 0;
    var st = live ? nflState(cart) : null;

    // texto: envío primero, boletos después, siempre los dos mientras haya promo
    var parts = [];
    if (min) parts.push(fsDone
      ? '<span class="fbm__ok">' + CHECK + 'Envío gratis</span>'
      : (mini ? 'Faltan <strong>' + money(fsRem) + '</strong> envío gratis' : 'Te faltan <strong>' + money(fsRem) + '</strong> para envío gratis'));
    if (st) {
      var tk = st.tickets ? '<strong>' + plural(st.tickets, 'boleto', 'boletos') + '</strong>' : '';
      if (st.spendT === HIGH_T) parts.push(tk + (mini ? ' NFL' : ' para el palco'));
      // siempre el total al que llega ESTA compra («para 2 boletos»), nunca «tu primer boleto»:
      // el cliente puede traer boletos de otras compras.
      else if (st.spendT === LOW_T) parts.push(tk + ' · ' + (mini ? 'faltan ' : 'te faltan ') + '<strong>' + money(HIGH - st.evaluable) + '</strong> para ' + plural(st.tickets + 1, 'boleto', 'boletos'));
      else if (st.tickets) parts.push(tk + ' · <strong>' + money(LOW - st.evaluable) + '</strong> más para ' + plural(st.tickets + 1, 'boleto', 'boletos'));
      else if (!n) parts.push('desde <strong>$3,500</strong> ganas boletos NFL');
      else parts.push((fsDone ? (mini ? 'faltan ' : 'te faltan ') : '') + '<strong>' + money(LOW - st.evaluable) + '</strong> para 1 boleto NFL');
    }
    var text = parts.join('<span class="fbm__sep">·</span>');

    // barra
    var scale = st ? HIGH : min;
    var amount = st ? Math.max(st.evaluable, Math.min(sub, min)) : sub;
    var pct = Math.max(0, Math.min(100, amount * 100 / scale));
    var ticks = '';
    function tick(at, label, done, cls) {
      var x = Math.max(0, Math.min(100, at * 100 / scale));
      ticks += '<span class="fbm__tick' + (done ? ' is-done' : '') + (cls ? ' ' + cls : '') + '" style="left:' + x.toFixed(2) + '%">'
        + (mini ? '' : '<i>' + label + '</i>') + '</span>';
    }
    if (st) {
      if (min && min < HIGH) tick(min, 'Envío', fsDone, 'fbm__tick--fs');
      tick(LOW, '1 boleto', st.spendT >= LOW_T, '');
      tick(HIGH, '2 boletos', st.spendT >= HIGH_T, 'fbm__tick--end');
    }

    var url = el.getAttribute('data-nfl-url');
    el.innerHTML = '<div class="fbm__bar' + (st ? ' has-nfl' : '') + (fsDone && (!st || st.spendT === HIGH_T) ? ' is-done' : '') + '">'
      + '<div class="fbm__top">'
      +   (st ? '<span class="fbm__ball">' + BALL + '</span>' : '<span class="fbm__truck">' + TRUCK + '</span>')
      +   '<p class="fbm__text">' + text + '</p>'
      + '</div>'
      + '<div class="fbm__meter" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '">'
      +   '<span class="fbm__fill" style="width:' + pct.toFixed(2) + '%"></span>' + ticks
      +   (st && !mini && url ? '<a class="fbm__link" href="' + url + '">Ver promo<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4 2.5L7.5 6 4 9.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></a>' : '')
      + '</div>'
      + '</div>';
    el.hidden = false;
  }

  var last = null;
  function render(cart) {
    if (cart) last = cart;
    if (!last) return;
    var els = document.querySelectorAll('[data-fb-meters]');
    for (var i = 0; i < els.length; i++) paint(els[i], last);
  }

  var pending = null;
  function refresh(e) {
    var c = e && e.detail && e.detail.cart;
    if (c && c.items) { render(c); return; }
    if (pending) return;
    pending = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () {})
      .then(function () { pending = null; });
  }

  window.FBMeters = { render: render, refresh: refresh };
  ['cart:updated', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, refresh); });

  // la página del carrito re-renderiza su sección desde el servidor: repinta los
  // contenedores nuevos con el último carrito conocido
  var root = document.querySelector('[data-fb-cart]');
  if (root && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var fresh = root.querySelector('[data-fb-meters]:empty');
      if (fresh) { render(); refresh(); }
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(); });
  else refresh();
})();
